module.exports = __webpack_public_path__ + "img/svg/recycle-fcaa5feb.svg";